import clickOutside from "../../click-outside";

class Menu {
    constructor() {
        this.toggles = document.querySelectorAll("[data-menu-toggle]");
        this.nav = document.querySelector("[data-nav]");
    }

    init = () => {
        [...this.toggles].map(toggle =>
            toggle.addEventListener("click", event => {
                const menu = toggle.dataset.menuToggle;
                const menuNode = document.querySelector(
                    `[data-menu="${menu}"]`
                );

                if (menuNode && !menuNode.classList.contains("is-open")) {
                    this.closeActiveMenu()(event);
                    toggle.classList.toggle("is-open");
                    menuNode.classList.toggle("is-open");
                } else {
                    this.closeActiveMenu()(event);
                }

                clickOutside(this.nav, this.outsideClickFunction());
            })
        );

        document.addEventListener("keydown", this.escapeFunction(), true);
    };

    outsideClickFunction = () => event => {
        this.closeActiveMenu()(event);
    };

    closeActiveMenu = () => event => {
        const openButton = document.querySelector([
            "[data-menu-toggle].is-open"
        ]);
        const openMenu = document.querySelector(["[data-menu].is-open"]);

        if (openButton && openMenu && !openMenu.contains(event.target)) {
            openButton.classList.remove("is-open");
            openMenu.classList.remove("is-open");
        }
    };

    escapeFunction = () => event => {
        if (event.keyCode === 27) {
            this.closeActiveMenu()(event);
        }
    };
}

const menu = new Menu();
menu.init();
